module.exports = "/_next/static/images/beatgig-256-1467b75294ce96f8eebdfdab2d8da900.png";